import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { getContentItemIconFromType } from 'utils/icons';
import isMultiDomain from 'utils/isMultiDomain';
import { BASIC } from 'styles/spacingPresets';
import Box from 'components/Box';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import InlineList from 'components/InlineList';
import Pill, { SectionLockingPill } from 'components/Pill';
import { SectionEditorModalUi } from 'screens/SectionEditorModal';
import { SelectableContentCard, SelectableSection, SelectableSectionChildren, SelectableSectionWrapper } from 'components/ContentCards';
import Stack from 'components/Stack';
import AssetEditor from 'screens/AssetEditor';
import PlaylistEditorModal from 'screens/PlaylistEditorModal';
import { checkIsValidMoveTarget } from './utils/checkIsValidMoveTarget';
import { getAllContentChildren } from './utils/getAllContentChildren';
import { formatAssetEditorPayload } from './utils/formatAssetEditorPayload';
import { formatPlaylistEditorPayload } from './utils/formatPlaylistEditorPayload';
import { Toolbar } from './components/Toolbar';
import { FloatingButtonLayout } from './components/FloatingButtonLayout';
import { Menu, AddContentMenuList } from './components/AddContentMenu';
import { FloatingMoveButton, FloatingAddSectionButton, FloatingAddContentButton } from './components/FloatingButtons';
import { PrimaryAddContentButton, PrimaryAddSectionButton, PrimaryMoveButton } from './components/PrimaryButtons';
import { useContentManagerSelection } from './useContentManagerSelection';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { ASSET_READ, PLAYLIST_WRITE, getCanMembersContribute, hasPrivilege, isTeamManager } from 'utils/privileges';
import { checkIsItemEditable } from './utils/checkIsItemEditable';
import config from 'utils/config';
import useBreakpoints from 'hooks/useBreakpoints';
export function PlaylistManageContentEditor(_ref) {
  var contentAsTree = _ref.contentAsTree,
    reducerState = _ref.reducerState,
    playlist = _ref.playlist,
    _ref$stickyHeaderComp = _ref.stickyHeaderCompensation,
    stickyHeaderCompensation = _ref$stickyHeaderComp === void 0 ? true : _ref$stickyHeaderComp;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasPlaylistNumbering = playlist.hasPlaylistNumbering;
  var _reducerState = _slicedToArray(reducerState, 2),
    _reducerState$ = _reducerState[0],
    content = _reducerState$.content,
    mobileInteractionMode = _reducerState$.mobileInteractionMode,
    dispatch = _reducerState[1];
  var _useBreakpoints = useBreakpoints('xs'),
    isDesktop = _useBreakpoints.xs;
  var isMovingEnabled = isDesktop || mobileInteractionMode === 'move';
  var canCreateAsset = useMemo(function () {
    return hasPrivilege(ASSET_READ) || config.managersCreateAssets && playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId) || getCanMembersContribute(playlist);
  }, [playlist]);
  var isPlaylistAdminOrTeamManager = useMemo(function () {
    return hasPrivilege(PLAYLIST_WRITE) || config.enableTeamPlaylists && playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId);
  }, [playlist]);
  var availableAddContentOptions;
  if (canCreateAsset && isPlaylistAdminOrTeamManager) {
    availableAddContentOptions = 'all';
  } else if (canCreateAsset) {
    availableAddContentOptions = 'new-only';
  } else if (isPlaylistAdminOrTeamManager) {
    availableAddContentOptions = 'existing-only';
  }
  var _useContentManagerSel = useContentManagerSelection({
      content: content,
      contentAsTree: contentAsTree
    }),
    hasSelectedItems = _useContentManagerSel.hasSelectedItems,
    selectedItemIds = _useContentManagerSel.selectedItemIds,
    selectedItems = _useContentManagerSel.selectedItems,
    clearSelection = _useContentManagerSel.clearSelection,
    getSelectRowHandler = _useContentManagerSel.getSelectRowHandler,
    getHighlightRowHandler = _useContentManagerSel.getHighlightRowHandler,
    getSelectSingleRowHandler = _useContentManagerSel.getSelectSingleRowHandler,
    handleGridSelectionKeys = _useContentManagerSel.handleGridSelectionKeys;
  function moveSelectedItems(_ref2) {
    var ids = _ref2.ids,
      targetRankInSection = _ref2.targetRankInSection,
      targetParentId = _ref2.targetParentId;
    dispatch({
      type: 'MOVE_CONTENT',
      ids: ids,
      targetRankInSection: targetRankInSection,
      targetParentId: targetParentId
    });
    clearSelection();
  }
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    itemIdToEdit = _useState2[0],
    setItemIdToEdit = _useState2[1];
  var closeItemEditor = function closeItemEditor() {
    return setItemIdToEdit(null);
  };
  var itemToEdit = content.find(function (item) {
    return item.id === itemIdToEdit;
  });
  var editorType;
  if (itemToEdit) {
    if (itemToEdit.type === 'section' || itemToEdit.type === 'playlist') {
      editorType = itemToEdit.type;
    } else {
      editorType = 'asset';
    }
  }
  function submitAssetEditor(_x) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
      var changes, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            changes = _ref3.changes;
            if (itemIdToEdit) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            data = formatAssetEditorPayload(itemIdToEdit, changes);
            dispatch({
              type: 'UPDATE_CONTENT',
              data: data
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  function submitPlaylistEditor(_x2) {
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function _submitPlaylistEditor() {
    _submitPlaylistEditor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(changes) {
      var data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (itemIdToEdit) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            data = formatPlaylistEditorPayload(itemIdToEdit, changes);
            dispatch({
              type: 'UPDATE_CONTENT',
              data: data
            });
            closeItemEditor();
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function submitSectionEditor(_x3) {
    return _submitSectionEditor.apply(this, arguments);
  }
  function _submitSectionEditor() {
    _submitSectionEditor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(changes) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (itemIdToEdit) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            dispatch({
              type: 'UPDATE_CONTENT',
              data: _objectSpread({
                id: itemIdToEdit
              }, changes)
            });
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _submitSectionEditor.apply(this, arguments);
  }
  var renderTree = function renderTree(_ref4) {
    var _itemsAtThisLevel$at, _content$find;
    var itemsAtThisLevel = _ref4.itemTree,
      parentId = _ref4.parentId,
      _ref4$level = _ref4.level,
      level = _ref4$level === void 0 ? 0 : _ref4$level,
      _ref4$path = _ref4.path,
      path = _ref4$path === void 0 ? [] : _ref4$path,
      _ref4$isParentSelecte = _ref4.isParentSelected,
      isParentSelected = _ref4$isParentSelecte === void 0 ? false : _ref4$isParentSelecte,
      name = _ref4.name;
    if (itemsAtThisLevel.length === 0) {
      var canMoveHere = checkIsValidMoveTarget({
        isMovingEnabled: isMovingEnabled,
        content: content,
        selectedItemIds: selectedItemIds,
        targetRankInSection: 0,
        targetParentId: parentId
      });
      return /*#__PURE__*/React.createElement(Flex, {
        border: "dashed",
        borderRadius: "small",
        p: "xs",
        minHeight: 75 // average content card height
      }, canMoveHere ? /*#__PURE__*/React.createElement(PrimaryMoveButton, {
        size: "default",
        onClick: function onClick() {
          return moveSelectedItems({
            ids: selectedItemIds,
            targetRankInSection: 0,
            targetParentId: parentId
          });
        },
        name: name
      }) : /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(PrimaryAddContentButton, {
        size: "default",
        name: name
      }), /*#__PURE__*/React.createElement(AddContentMenuList, {
        dispatch: dispatch,
        targetParentId: parentId,
        targetRankInSection: 0,
        canAddSection: level < 2,
        availableOptions: availableAddContentOptions
      })));
    }
    var firstSectionIndex = itemsAtThisLevel.findIndex(function (item) {
      return item.type === 'section';
    });
    var isSectionList = firstSectionIndex > -1;
    var rankAfterLastItem = (((_itemsAtThisLevel$at = itemsAtThisLevel.at(-1)) === null || _itemsAtThisLevel$at === void 0 ? void 0 : _itemsAtThisLevel$at.rankInSection) || 0) + 1;
    var canMoveToEndOfList = checkIsValidMoveTarget({
      isMovingEnabled: isMovingEnabled,
      content: content,
      selectedItemIds: selectedItemIds,
      targetRankInSection: rankAfterLastItem,
      targetParentId: parentId
    });

    // When there's a selection, we're hiding any floating '+' buttons
    // to make it easier to see available move targets
    var hasFloatingAddButtons = !hasSelectedItems;
    var subsectionName = (_content$find = content.find(function (item) {
      return item.id === parentId;
    })) === null || _content$find === void 0 ? void 0 : _content$find.name;
    return /*#__PURE__*/React.createElement(Stack, {
      spacing: BASIC.SMALL,
      breakpoints: BASIC.BREAKPOINTS
    }, itemsAtThisLevel.map(function (item, index) {
      var id = item.id,
        itemParentId = item.parent_id,
        rankInSection = item.rankInSection,
        name = item.name,
        description = item.description,
        type = item.type,
        children = item.children;
      var isContentEditable = checkIsItemEditable({
        item: item,
        parentPlaylistMemberContributions: playlist.allow_member_contributions,
        parentPlaylistOwnerTeamId: playlist.ownerTeamId
      });
      var isFirstSection = index === firstSectionIndex;
      var currentPath = [].concat(_toConsumableArray(path), [index + 1]);
      var itemNumber = currentPath.join('.');
      if (type === 'section') {
        var isSectionSelected = selectedItemIds.includes(id);
        var renderedChildren = renderTree({
          itemTree: children,
          parentId: id,
          level: level + 1,
          path: currentPath,
          isParentSelected: isParentSelected || isSectionSelected,
          name: name
        });
        var _canMoveHere = checkIsValidMoveTarget({
          isMovingEnabled: isMovingEnabled,
          content: content,
          selectedItemIds: selectedItemIds,
          targetRankInSection: rankInSection,
          targetParentId: parentId
        });
        var childContentCount = getAllContentChildren(children).length;
        return /*#__PURE__*/React.createElement(SelectableSectionWrapper, {
          key: id,
          isSelected: isSectionSelected && !isParentSelected
        }, /*#__PURE__*/React.createElement(FloatingButtonLayout, {
          showAlways: _canMoveHere,
          buttonOffset: -15,
          button: _canMoveHere ? /*#__PURE__*/React.createElement(FloatingMoveButton, {
            onClick: function onClick() {
              return moveSelectedItems({
                ids: selectedItemIds,
                targetRankInSection: rankInSection,
                targetParentId: parentId
              });
            },
            name: name,
            level: level
          }) : isFirstSection && hasFloatingAddButtons ? /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(FloatingAddContentButton, {
            name: name,
            level: level
          }), /*#__PURE__*/React.createElement(AddContentMenuList, {
            canAddSection: true,
            dispatch: dispatch,
            targetParentId: parentId,
            targetRankInSection: rankInSection,
            availableOptions: availableAddContentOptions
          })) : hasFloatingAddButtons && isPlaylistAdminOrTeamManager && /*#__PURE__*/React.createElement(FloatingAddSectionButton, {
            onClick: function onClick() {
              return dispatch({
                type: 'REQUEST_NEW_CONTENT',
                variant: 'new-section',
                targetParentId: parentId,
                targetRankInSection: rankInSection
              });
            },
            name: name,
            level: level
          })
        }, /*#__PURE__*/React.createElement(SelectableSection, {
          isPlaylistAdminOrTeamManager: isPlaylistAdminOrTeamManager,
          name: name,
          description: description,
          number: itemNumber,
          isSelected: isSectionSelected,
          isSelectionDisabled: isParentSelected,
          onToggleSelection: getSelectRowHandler(id),
          onClick: getSelectSingleRowHandler(id),
          onMouseOver: getHighlightRowHandler(id),
          onRequestEdit: function onRequestEdit() {
            return setItemIdToEdit(id);
          },
          contentInfo: /*#__PURE__*/React.createElement(InlineList, {
            spacing: "xs"
          }, /*#__PURE__*/React.createElement(Pill, null, t('playlist_item_count', {
            count: childContentCount
          })), /*#__PURE__*/React.createElement(SectionLockingPill, {
            isShown: true,
            lockingMode: item.lockingMode,
            unlockDateTime: item.unlockDateTime,
            unlockTimezone: item.unlockTimezone
          })),
          hasPlaylistNumbering: hasPlaylistNumbering
        })), /*#__PURE__*/React.createElement(SelectableSectionChildren, null, renderedChildren));
      } else {
        var _canMoveHere2 = checkIsValidMoveTarget({
          isMovingEnabled: isMovingEnabled,
          content: content,
          selectedItemIds: selectedItemIds,
          targetRankInSection: rankInSection,
          targetParentId: itemParentId
        });
        var basicContentType = getContentItemType(item);
        var translatableType = getContentItemTypeTranslationKey(basicContentType);
        var icon = getContentItemIconFromType(basicContentType);
        var isDistributed = isMultiDomain(item);
        return /*#__PURE__*/React.createElement(FloatingButtonLayout, {
          key: id,
          buttonOffset: "-s",
          showAlways: _canMoveHere2,
          button: _canMoveHere2 ? /*#__PURE__*/React.createElement(FloatingMoveButton, {
            onClick: function onClick() {
              return moveSelectedItems({
                ids: selectedItemIds,
                targetParentId: parentId,
                targetRankInSection: rankInSection
              });
            },
            name: name,
            level: level
          }) : hasFloatingAddButtons && /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(FloatingAddContentButton, {
            name: name,
            level: level
          }), /*#__PURE__*/React.createElement(AddContentMenuList, {
            canAddSection: level < 2,
            dispatch: dispatch,
            targetParentId: parentId,
            targetRankInSection: rankInSection,
            availableOptions: availableAddContentOptions
          }))
        }, /*#__PURE__*/React.createElement(SelectableContentCard, {
          isContentEditable: isContentEditable,
          title: name,
          translatedType: t(translatableType),
          type: item.type,
          icon: icon,
          isOptional: item.optional,
          number: itemNumber,
          changesCount: item.changedFields.size,
          imageSource: getPictureUrl({
            id: item.thumbnailId,
            dimensions: DIMENSIONS.HORIZONTAL_CARD
          }),
          isSelected: selectedItemIds.includes(id),
          isSelectionDisabled: isParentSelected,
          onToggleSelection: getSelectRowHandler(id),
          onClick: getSelectSingleRowHandler(id),
          onMouseOver: getHighlightRowHandler(id),
          onRequestEdit: function onRequestEdit() {
            return setItemIdToEdit(id);
          },
          isDistributed: isDistributed,
          fileId: 'fileId' in item ? item.fileId : undefined,
          contentFileStatus: 'fileStatus' in item ? item.fileStatus : undefined,
          hasPlaylistNumbering: hasPlaylistNumbering
        }));
      }
    }), canMoveToEndOfList ? /*#__PURE__*/React.createElement(PrimaryMoveButton, {
      onClick: function onClick() {
        return moveSelectedItems({
          ids: selectedItemIds,
          targetParentId: parentId,
          targetRankInSection: rankAfterLastItem
        });
      },
      name: subsectionName
    }) : isSectionList ? isPlaylistAdminOrTeamManager && /*#__PURE__*/React.createElement(PrimaryAddSectionButton, {
      level: level,
      onClick: function onClick() {
        return dispatch({
          type: 'REQUEST_NEW_CONTENT',
          variant: 'new-section',
          targetParentId: parentId,
          targetRankInSection: rankAfterLastItem
        });
      },
      name: subsectionName
    }) : /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(PrimaryAddContentButton, {
      name: subsectionName
    }), /*#__PURE__*/React.createElement(AddContentMenuList, {
      canAddSection: level < 2,
      dispatch: dispatch,
      targetParentId: parentId,
      targetRankInSection: rankAfterLastItem,
      availableOptions: availableAddContentOptions
    })));
  };
  return /*#__PURE__*/React.createElement(Card, {
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS,
    overflow: "visible",
    onKeyDown: handleGridSelectionKeys
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS
  }, t('actions_manage_content')), /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(Toolbar, {
    selectedItems: selectedItems,
    selectedItemIds: selectedItemIds,
    clearSelection: clearSelection,
    reducerState: reducerState,
    setItemIdToEdit: setItemIdToEdit,
    stickyHeaderCompensation: stickyHeaderCompensation,
    playlist: playlist
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "m",
    mt: BASIC.MEDIUM,
    ml: mobileInteractionMode === 'move' ? 'm' : undefined,
    breakpoints: BASIC.BREAKPOINTS
  }, renderTree({
    itemTree: contentAsTree
  })), editorType === 'section' && /*#__PURE__*/React.createElement(SectionEditorModalUi, {
    initialSectionData: itemToEdit,
    onSubmit: submitSectionEditor,
    onClose: closeItemEditor,
    inContentManagerContext: true
  }), editorType === 'asset' && /*#__PURE__*/React.createElement(AssetEditor, {
    asset: itemToEdit,
    parentPlaylist: playlist,
    onSubmit: submitAssetEditor,
    onClose: closeItemEditor,
    inContentManagerContext: true
  }), editorType === 'playlist' && /*#__PURE__*/React.createElement(PlaylistEditorModal, {
    playlist: itemToEdit,
    parentPlaylist: playlist,
    onSubmit: submitPlaylistEditor,
    onClose: closeItemEditor,
    inContentManagerContext: true
  })));
}